module.exports = __webpack_public_path__ + "static/media/11a-04_ST-2011-75x100cm-oleo-sobre-papel.67eb7cc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/11/11a-04_ST-2011-75x100cm-oleo-sobre-papel.jpg
// module id = 124
// module chunks = 0